import { SubscriptionRole } from '@/types';

/**
 * Where an authenticated user lands.
 *
 * Lives here rather than in a component because two places need it and they
 * cannot share state: Login.tsx decides right after the token request, when
 * useAuth() has not re-rendered with the fresh roles yet, and LoginRoute
 * decides for a session that is already hydrated. Keeping one function means
 * the precedence below is written once.
 *
 * Pure ADMIN accounts have no clubs or tournaments, so the usual landing pages
 * are empty for them. Checked before FUTURE_OWNER: the order matters.
 */
export const resolvePostLoginRoute = (
  // A default parameter only covers `undefined`, and the backend types roles as
  // `Set<String>? = null`: a null would reach `.includes` and throw after the
  // tokens were already stored, stranding the user on /login.
  rolesOrNull?: string[] | null,
): string => {
  const roles = rolesOrNull ?? [];

  const isPureAdmin =
    roles.includes(SubscriptionRole.ADMIN) &&
    !roles.includes(SubscriptionRole.OWNER) &&
    !roles.includes(SubscriptionRole.MANAGER) &&
    !roles.includes(SubscriptionRole.INSTRUCTOR);
  if (isPureAdmin) {
    return '/admin/usuarios';
  }

  const isFutureOwner =
    roles.includes(SubscriptionRole.FUTURE_OWNER) &&
    !roles.includes(SubscriptionRole.OWNER) &&
    !roles.includes(SubscriptionRole.MANAGER);
  return isFutureOwner ? '/clubs' : '/inicio';
};
